// Test-prod environment. URL fields exposed as getters — see environment.ts for rationale.

import { deriveBackendOrigin } from 'src/app/core/_helpers/derive-origin';

export const environment = {
  production: true,

  get apiBase(): string {
    return deriveBackendOrigin().origin + '/api/';
  },
  get backendBase(): string {
    return deriveBackendOrigin().origin;
  },
  get host(): string {
    return deriveBackendOrigin().host;
  },

  azureADClientID: '47a6b87d-a744-4f5a-ba3c-c2120befb1f4',
  googleClientID: '391804863255-hog71rc56ak8vped7sle6i2i6etkbus4.apps.googleusercontent.com',
  googleMapsAPI: 'AIzaSyCLEkWPekL9yHBdheOSCd837Siilky1lO8',
  facebookAppID: '519232895226979',
  appVersion: require('../../package.json').version + '-d' + '-test',
  tookanURL: "https://private-anon-65f34dd33d-tookanapi.apiary-mock.com/v2/",
  nativeApp: false,
  // Delivery app ne koristi WS — lista se osvežava pollingom, naplata/aktivnost preko REST check-in-a.
  disableWebsocket: true
};
